module.exports = __webpack_public_path__ + "static/product-improvement-sourcing-9dab40716efd00e10805a207e3b2faed.png";